import React, { useState, useMemo } from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import EditIcon from '@material-ui/icons/Edit'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'

import LinkButtonWithText from 'Components/Buttons/LinkButtonWithText'
import StyledIconButton from 'Components/Form/StyledIconButton'
import SubmitButton from 'Components/Form/SubmitButton'
import { CONFIG } from 'Config/config'
import { authorization } from 'Module/Auth/Auth'

import CityPage from '../index'
import AmbassadorsPipelineView from './AmbassadorsPipelineView'
import AmbassadorsListView from './AmbassadorsListView'

function Ambassadors(props) {
  const {
    cityId,
    classes,
    cityName,
    newcomersMissionsLimit,
    recruitmentOnHold,
    match: { url },
  } = props

  const [viewType, setViewType] = useState('pipeline')

  const [exportUnfilledUrl, exportUrl, breadcrumbData] = useMemo(() => {
    const apiKey = authorization.getAPIKey()
    const baseUrl = CONFIG.API_BASE_URL

    // If the city is loaded add that to the spreadsheet name
    const encodeUnfilled = encodeURIComponent(
      cityName
        ? `${cityName.toLowerCase()}-unfilled-availabilities`
        : 'unfilled-availabilities',
    )
    const encodeFilled = encodeURIComponent(
      cityName ? `${cityName.toLowerCase()}-ambassadors` : 'ambassadors',
    )

    return [
      `${baseUrl}/cities/${cityId}/ambassadors/unfilled-availabilities-csv/${encodeUnfilled}?apiKey=${apiKey}`,
      `${baseUrl}/cities/${cityId}/ambassadors/csv/${encodeFilled}?apiKey=${apiKey}`,
      { title: 'Brand Ambassadors', pathname: url },
    ]
  }, [cityName, cityId, url])

  return (
    <CityPage
      active={props.nav}
      cityId={props.cityId}
      history={props.history}
      match={props.match}
      cityName={cityName}
      newcomersMissionsLimit={newcomersMissionsLimit}
      recruitmentOnHold={recruitmentOnHold}
    >
      <Breadcrumb data={breadcrumbData} />
      <div className="button-container">
        <LinkButtonWithText
          target="_blank"
          href={exportUnfilledUrl}
          label="Unfilled Availabilities"
          title="Export a list of unfilled brand ambassadors availabilities"
        />
        <LinkButtonWithText
          target="_blank"
          href={exportUrl}
          label="Export"
          title="Export a list of brand ambassadors"
        />
      </div>
      <StyledIconButton href={url + '/edit'} className="link-edit-main">
        <EditIcon />
      </StyledIconButton>
      <div className={classes.controls}>
        <ButtonGroup disableElevation color="primary">
          <SubmitButton
            value="List"
            variant={viewType === 'list' ? 'contained' : 'outlined'}
            onClick={() => setViewType('list')}
          />
          <SubmitButton
            value="Pipeline"
            variant={viewType === 'pipeline' ? 'contained' : 'outlined'}
            onClick={() => setViewType('pipeline')}
          />
        </ButtonGroup>
        <Link
          to="manage-onboarding-times"
          style={{ textDecoration: 'none' }}
          className="manage-onboarding-button"
        >
          <SubmitButton>Manage Onboarding times</SubmitButton>
        </Link>
      </div>
      {viewType === 'list' && <AmbassadorsListView cityId={cityId} />}
      {viewType === 'pipeline' && <AmbassadorsPipelineView cityId={cityId} />}
    </CityPage>
  )
}

const styles = {
  controls: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 44px 10px',
  },
}

export default withStyles(styles)(Ambassadors)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/index.js